


































































































































import moment from 'moment';
import { Component, Prop } from 'vue-property-decorator';
import { GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import MantenedorGridVerDetalle from '@/reusable/Grid/MantenedorGrid.vue';
import { LoadingService } from '@/services/loadingService';
import CabeceraTabla from '@/reusable/Grid/CabeceraTabla.vue';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import { Funcionalidades } from '@/config/funcionalidades';
import { Snotify } from '@/snotify/Snotify';
import BuscadorOperacionCrud from '@/reusable/Grid/BuscadorOperacionCrud.vue';
import StepTitle from '@/reusable/Mantenedor/StepTitle.vue';
import {
  codigoAccionesMenuItem,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';
import { fetchReportesSerie } from './fetchReporteSerie';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';

@Component({
  components: {
    StepTitle,
    BuscadorOperacionCrud,
    CabeceraTabla,
    MantenedorGrid,
    MantenedorGridVerDetalle,
    FormFieldsContainer,
  },
})
export default class SimDesactivadoresForm extends ComponenteBase {
  @Prop({ default: false }) disabled: boolean;
  @Prop({ default: null }) serieNumeroSeleccionado: any;
  @Prop({ default: null }) simestadolistSeleccionado: any;
  @Prop({ default: false }) modoVer: boolean;

  /* ComponenteBase */
  ordesList: any;
  ordesList2: any;
  serverSide: any;
  showReporteGenerado: boolean = false;
  usuariorut: string = '';
  estadoid: string = '';

  accionConsultar: PermisoAccion = {
    accionCodigo: 1,
    visible: false,
  };

  accionExportar: PermisoAccion = {
    accionCodigo: 6,
    visible: true,
  };

  accionesTotales: PermisoAccion[] = [
    this.accionConsultar,
    this.accionExportar,
  ];
  readonly codigoAccionesMenuItem = Object.values(codigoAccionesMenuItem);
  readonly funcionalidad: Funcionalidades = Funcionalidades.ReportesSerie;
  simestadolist: any[] = [];
  /* aggrid */

  gridApi: GridApi = null;

  /* template */

  readonly gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'Fecha de Desactivación',
        field: 'simdesactivafecha',
        lockVisible: true,
        valueFormatter: function(params) {
          return moment(params.value).format('YYYY-MM-DD HH:MM:SS');
        },
      },
      {
        headerName: 'Nota',
        field: 'simdesactivaobs',
        lockVisible: true,
      },
      {
        headerName: 'Nombre',
        field: 'nombre',
        lockVisible: true,
      },
      {
        headerName: 'Estado',
        field: 'configvalor',
        lockVisible: true,
      },
      {
        headerName: 'Motivo',
        field: 'motivo',
        lockVisible: true,
      },
    ],
    pagination: true,
    singleClickEdit: true,
    paginationPageSize: 5,
    onGridReady: this.handleGridReady,
    suppressCopyRowsToClipboard: true,
  };

  /* misc */

  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();

  /* event handlers */
  motivos: any = [];
  async usuario_actual() {
    return fetchReportesSerie(
      {
        usuarioid: JSON.parse(localStorage.getItem('user')).id,
      },
      'conecta_inventario_sim/usuario'
    )
      .then(async (data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.formFields.usuario.value = data.data.data[0].nombre;
          this.motivos = data.data.motivos;
        } else {
          return;
        }
      })
      .catch((error: any) => {
        return;
      })
      .finally(() => {
        return null;
      });
  }

  async getSerie_by_id(serieNumeroSeleccionado: any) {
    let self = this;
    this.loadingService.showLoading();
    return fetchReportesSerie(
      {
        serienumero: serieNumeroSeleccionado,
      },
      'conecta_inventario_sim/desactivadores'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          if (data.data.data[0].STATUS == 'SIN_DATA') {
            self.gridApi.showNoRowsOverlay();
            return;
          }

          return data.data.data;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        return;
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async handleGridReady(event: GridReadyEvent) {
    this.ordesList = await this.getSerie_by_id(this.serieNumeroSeleccionado);
    this.gridApi = event.api;
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
    this.serverSide = {};
  }
  crear_estado() {
    this.usuario_actual();
    this.showReporteGenerado = true;
  }
  closeReporte() {
    this.showReporteGenerado = false;
  }
  getconfigOptions() {
    if (this.formFields.simestado.value === 'Activado') {
      this.estadoid = '1';
    } else if (this.formFields.simestado.value === 'Activacion lista') {
      this.estadoid = '3';
    } else if (this.formFields.simestado.value === 'Desactivado') {
      this.estadoid = '2';
    } else if (this.formFields.simestado.value === 'Nuevo inactivo') {
      this.estadoid = '4';
    }
  }

  guardar(serieNumeroSeleccionado: any) {
    let self = this;

    return fetchReportesSerie(
      {
        serienumero: this.serieNumeroSeleccionado,
        fecha_modifica: this.formFields.fechadesactivacion.value,
        estado: this.formFields.simestado.value,
        observacion: this.formFields.nota.value,
        usuarioid: JSON.parse(localStorage.getItem('user')).id,
        usuariorut: JSON.parse(localStorage.getItem('user')).rutClienteDefecto,
        estadoid: this.estadoid,
        motiid: this.formFields.motivos.value,
      },
      'conecta_inventario_sim/insertar_estado'
    )
      .then(async (data: any) => {
        if (self.formFields.simestado.value == '') {
          self.$snotify.error('El campo Estado debe ser diligenciado', {
            timeout: 3000,
          });
        }
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.ordesList = await this.getSerie_by_id(
            this.serieNumeroSeleccionado
          );
          this.gridApi.setRowData(this.ordesList);
          self.$snotify.success(
            'Actualizado con éxito el estado a :' +
              this.formFields.simestado.value,
            { timeout: 3000 }
          );
          this.showReporteGenerado = false;
        } else {
          return;
        }
      })
      .catch((error: any) => {
        self.$snotify.success(
          'Actualizado con éxito el estado a :' +
            this.formFields.simestado.label,
          { timeout: 3000 }
        );
        this.showReporteGenerado = false;
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async getEquipos() {
    let self = this;
    this.loadingService.showLoading();
    return fetchReportesSerie(
      { '': '' },
      'conecta_inventario_sim/get_grilla_filters'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.simestadolist = data.data.SIMESTADO;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        return;
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  formFields: FormFieldDefMap = {
    usuario: {
      label: 'Usuario',
      id: '',
      value: '',
    },
    nota: {
      label: 'Nota',
      id: '',
      value: '',
    },
    fechadesactivacion: {
      label: 'Fecha Desactivación',
      id: 'fechadesactiva',
      value: moment().format('YYYY-MM-DD h:mm:ss'),
    },
    simestado: {
      label: 'Estado Sim',
      id: '',
      value: '',
    },
    motivos: {
      label: 'Motivos',
      id: '',
      value: '',
    },
  };

  mounted() {
    this.getEquipos();
  }
}
